import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import swal from 'sweetalert';

import { ActivatedRoute } from "@angular/router";




import * as JSZip from 'jszip';

import { InicioService } from '../../services/inicio.service';

@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.css']
})
export class SeguimientoComponent implements OnInit {

  // Objeto Formulario
  objetoPFis = {};
  objetoPMor = {};

  // Formulario
  rfcForm: FormGroup;
  pMoralForm: FormGroup;
  pFisicaForm: FormGroup;

  // Validaciones
  submitted: boolean;
  submittedF: boolean;
  submittedRfc: boolean;
  tokenValido: boolean;
  cargando: boolean;
  pFisica: boolean;
  pMoral: boolean;
  mayor2500000: boolean;
  envioCorrecto: boolean;
  cargaArchivos: boolean;

  fecha = new Date();
  anio = this.fecha.getFullYear();

  anioMenosUno = this.anio;
  anioMenosDos = this.anio - 1;
  // error
  msgError: string;

  // Campos
  rfc_contratista: string;
  idContratista: number;
  emailContratista: string;
  nombreContratista: string;

  rfc: string;
  tkn: string;

  constructor(private formBuilder: FormBuilder, private _inicioService: InicioService, private route: ActivatedRoute) {
    this.tokenValido = false;
    this.cargando = false;
    this.pFisica = false;
    this.pMoral = false;
    this.submitted = false;
    this.submittedF = false;
    this.submittedRfc = false;
    this.envioCorrecto = false;
    this.cargaArchivos = false;



    this.rfc_contratista = '';

    // prueba servico files

    // this._inicioService.prueba().subscribe(data => console.log(data));


    this.objetoPMor = {
      actaRfc: ['', [Validators.required, validarDocumento]],
      poderRfc: ['', [Validators.required, validarDocumento]],
      identificacionRfc: ['', [Validators.required, validarDocumento]],
      rfcRepresentante: ['', [Validators.required, validarDocumento]],
      rfcEmpresa: ['', [Validators.required, validarDocumento]],
      regPatronal: ['', [Validators.required, validarDocumento]],
      comprobanteRfc: ['', [Validators.required, validarDocumento]],
      edoCtaRfc: ['', [Validators.required, validarDocumento]],
      // cartaLineaRfc: ['', [Validators.required, validarDocumento]],
      edoFinAuditadosPM: ['', [Validators.required, validarDocumento]],
      edoFinInternosPM: ['', [Validators.required, validarDocumento]],
      relActActivosPM: ['', [Validators.required, validarDocumento]],
    };

    this.objetoPFis = {
      identificacionOficial: ['', [Validators.required, validarDocumento]],
      rfcFisica: ['', [Validators.required, validarDocumento]],
      registroPatronalF: ['', [Validators.required, validarDocumento]],
      edoCtaF: ['', [Validators.required, validarDocumento]],
      comprobanteDomF: ['', [Validators.required, validarDocumento]],
      // cartaLineaF: ['', [Validators.required, validarDocumento]]
      edoFinAuditadosPF: ['', [ validarDocumento]],
      edoFinInternosPF: ['', [Validators.required, validarDocumento]],
      relActActivosPF: ['', [Validators.required, validarDocumento]],
    };
  }

  ngOnInit() {

    this.rfc = this.route.snapshot.queryParamMap.get("r");
    this.tkn = this.route.snapshot.queryParamMap.get("t");
    console.log(this.rfc);
    console.log(this.tkn);

    // Form RFC
    this.rfcForm = this.formBuilder.group({
      rfcContratista: ['', Validators.required],
      tokenContratista: ['', Validators.required]
    });

    // Formulario de persona Moral
    this.pMoralForm = this.formBuilder.group(this.objetoPMor);

    // Formulario de persona física
    this.pFisicaForm = this.formBuilder.group(this.objetoPFis);

    if (this.rfc !== null && this.tkn !== null) {

      console.log('Not null')
      this.rfcForm.setValue({
        rfcContratista: this.rfc,
        tokenContratista: this.tkn
      });

      console.log(this.rfcForm.value)

    }

  }


  /*       -------------COMIENZA VALIDACIÓN DE RFC Y TOKEN ----------------     */
  submitRFC() {
    this.submittedRfc = true; // activa bandera para mostrar errores de validación


    if (this.rfcForm.invalid) {// valida que el fomulario esté correcto
      this.msgError = `Favor de llenar correctamente los campos`;

      return;
    }



    this.cargando = true; // spinner de carga


    // obtiene los alores del formulario
    const formData = new FormData();
    formData.append('rfcContratista', this.rfcForm.get('rfcContratista').value);
    formData.append('tokenContratista', this.rfcForm.get('tokenContratista').value);

    // Servicio
    this._inicioService.validaRFC(formData)
      .subscribe((data: any) => {
        if (typeof (data.usuarios) !== 'undefined') { // Si encontró resultados

          if (data.usuarios.solicita_documentos !== 1) {
            swal('Importante!', `No se han solicitado documentos para este contratista.
                Favor de comunicarse al área de administración de Tierra y Armonía para solicitar información de su estatus.`, 'error');
            this.msgError = `No se han solicitado documentos para este contratista. `;
            this.cargando = false;
            return;
          }

          /* Obtener campos desde la base de datos */
          // Se obtiene el id del Contratista
          this.idContratista = data.usuarios.idContratista;
          // Se obtiene el correo electrónico
          this.emailContratista = data.usuarios.correo;
          // Se obtiene el nombre del contratista
          this.nombreContratista = data.usuarios.nombre;
          // se valida si es persona física o moral
          if (data.usuarios.rfc.length === 13) {
            this.pFisica = true;     // Pruebas, verifica que el contratista sea persona Física
          } else if (data.usuarios.rfc.length === 12) {
            this.pMoral = true;     // Pruebas, verifica que el contratista sea persona Moral
          } else {
            this.cargando = false;
            this.msgError = `Hay un error con el RFC. Favor de verificar.`;
            return;
          }

          // Se valida el tipo de usuario asignado por calidad
          if (data.usuarios.tipo === '1') {
            this.mayor2500000 = false;     // Pruebas, verifica que el contratista sea de más de 2,500,000
          } else if (data.usuarios.tipo === '2') {
            this.mayor2500000 = true;     // Pruebas, verifica que el contratista sea de más de 2,500,000
          } else {
            this.msgError = `Error en el tipo de contratista. Favor de contactar al administrador`;
            swal('Importante!', `No ha sido asignado un tipo de contratista. Por favor, contacte al área de calidad de TyA`, 'error');
            this.cargando = false;
            return;
          }

          // si pasa las validaciones se muestra el formulario de carga de archivos de acuerdo a las condiciones anteriores
          swal({
            title: '',
            text: 'RFC y token correctos!',
            icon: 'success',
            buttons: [false],
            timer: 1500
          })
            .then(() => {

              this.cargando = false;
              this.tokenValido = true; // muestra el formulario inicial
              this.cargaArchivos = true; // permite que se muestre el formulario de archivos
              swal('Importante!', `Para la Carta línea de afianzamiento solo se permiten las siguientes afianzadoras: 
    •	FIANZAS ATLAS, S.A.
    •	ACE FIANZAS MONTERREY, S.A.
    •	AFIANZADORA ASERTA-INSURGENTES, S.A. DE C.V. GRUPO FINANCIERO ASERTA`, 'info');
              this.rfc_contratista = this.rfcForm.get('rfcContratista').value;

              if (this.mayor2500000 && this.pFisica) {// se agrega campo de carta de linea de credito
                this.objetoPFis['cartaLineaF'] = ['', [Validators.required, validarDocumento]];
                this.pFisicaForm = this.formBuilder.group(this.objetoPFis);
              }
              if (this.mayor2500000 && this.pMoral) {// se agrega campo de carta de linea de credito
                this.objetoPMor['cartaLineaRfc'] = ['', [Validators.required, validarDocumento]];
                this.pMoralForm = this.formBuilder.group(this.objetoPMor);
              }
            });

        } else { // la consulta no retorna resultados de la base de datos
          this.tokenValido = false; // muestra el formulario inicial si es falso
          this.cargaArchivos = false; // permite que se muestre el formulario de archivos
          this.cargando = false;
          this.msgError = `RFC o token inválido. Intente de nuevo, por favor`;
        }
      }, (error) => {
        swal('Atención!', 
        `Sucedió un problema: 
        ${error}`, 
        'error');
        this.cargando = false;
      });

    // Termina prueba servicio


  }
  /*        ---------------------TERMINA VALIDACIÓN DE RFC Y TOKEN --------------------------------        */



  inputs(event) {
    // console.log(event.target);
    const nombre = event.target.name;
    switch (nombre) {
      case 'rfcContratista':
        this.rfcForm.get('rfcContratista').setValue(event.target.value);
        console.log(this.rfcForm.get('rfcContratista'));
        break;
      case 'tokenContratista':
        this.rfcForm.get('tokenContratista').setValue(event.target.value);
        // console.log('El token es: ' + event.target.value);
        break;
    }
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {

      const nombre = event.target.name;
      console.log(nombre);

      const file = event.target.files[0];

      switch (nombre) {
        /* ----------- Inputs de persona Moral ---------------------*/
        case 'actaRfc':
          this.pMoralForm.get('actaRfc').setValue(file);
          break;
        case 'poderRfc':
          this.pMoralForm.get('poderRfc').setValue(file);
          break;
        case 'identificacionRfc':
          this.pMoralForm.get('identificacionRfc').setValue(file);
          break;
        case 'rfcRepresentante':
          this.pMoralForm.get('rfcRepresentante').setValue(file);
          break;
        case 'rfcEmpresa':
          this.pMoralForm.get('rfcEmpresa').setValue(file);
          break;
        case 'regPatronal':
          this.pMoralForm.get('regPatronal').setValue(file);
          break;
        case 'comprobanteRfc':
          this.pMoralForm.get('comprobanteRfc').setValue(file);
          break;
        case 'edoCtaRfc':
          this.pMoralForm.get('edoCtaRfc').setValue(file);
          break;
        case 'cartaLineaRfc':

          this.pMoralForm.get('cartaLineaRfc').setValue(file);

          break;

        // Auditoría
        case 'edoFinAuditadosPM':
          this.pMoralForm.get('edoFinAuditadosPM').setValue(file);
          break;
        case 'edoFinInternosPM':
          this.pMoralForm.get('edoFinInternosPM').setValue(file);
          break;
        case 'relActActivosPM':
          this.pMoralForm.get('relActActivosPM').setValue(file);
          break;

        /* ------------ Inputs persona Física ------------------------*/
        case 'identificacionOficial':
          this.pFisicaForm.get('identificacionOficial').setValue(file);
          break;
        case 'rfcFisica':
          this.pFisicaForm.get('rfcFisica').setValue(file);
          break;
        case 'registroPatronalF':
          this.pFisicaForm.get('registroPatronalF').setValue(file);
          break;
        case 'edoCtaF':
          this.pFisicaForm.get('edoCtaF').setValue(file);
          break;
        case 'comprobanteDomF':
          this.pFisicaForm.get('comprobanteDomF').setValue(file);
          break;
        case 'cartaLineaF':

          this.pFisicaForm.get('cartaLineaF').setValue(file);
          break;

        // Auditoría

        case 'edoFinAuditadosPF':
          this.pFisicaForm.get('edoFinAuditadosPF').setValue(file);
          break;
        case 'edoFinInternosPF':
          this.pFisicaForm.get('edoFinInternosPF').setValue(file);
          break;
        case 'relActActivosPF':
          this.pFisicaForm.get('relActActivosPF').setValue(file);
          break;

      }
      // console.log(file);
    }
  }

  // convenience getter for easy access to form fields
  get m() { return this.pMoralForm.controls; }

  get f() { return this.pFisicaForm.controls; }



  /**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/
  /**+++++++++++++++++++++++++++Submit Persona MORAL+++++++++++++++++++++++++++++**/
  /**++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/

  onSubmitMoral() {
    this.submitted = true; // activa validaciones del formulario

    this.cargando = true;
    const servicio = this._inicioService;
    const str_rfc = this.rfc_contratista;
    const id_contratista = this.idContratista;
    const _this = this;

    if(this.pMoralForm.get('edoFinAuditadosPM').value === '' || this.pMoralForm.get('edoFinAuditadosPM').value === null) 
    {
      this.pMoralForm.get('edoFinAuditadosPM').setValidators([]);
      this.pMoralForm.get('edoFinAuditadosPM').updateValueAndValidity();;

    } else{
      this.pMoralForm.get('edoFinAuditadosPM').setValidators([validarDocumento]);
      this.pMoralForm.get('edoFinAuditadosPM').updateValueAndValidity();;
    }

    if (this.pMoralForm.invalid) {
      // console.log(this.pMoralForm.invalid);
      this.cargando = false;
      return;
    }
    /************************ JSPDF*************************** */

    const zip = new JSZip();
    zip.file('actaRfc.pdf', this.pMoralForm.get('actaRfc').value);
    zip.file('poderRfc.pdf', this.pMoralForm.get('poderRfc').value);
    zip.file('identificacionRfc.pdf', this.pMoralForm.get('identificacionRfc').value);
    zip.file('rfcRepresentante.pdf', this.pMoralForm.get('rfcRepresentante').value);
    zip.file('rfcEmpresa.pdf', this.pMoralForm.get('rfcEmpresa').value);
    zip.file('regPatronal.pdf', this.pMoralForm.get('regPatronal').value);
    zip.file('comprobanteRfc.pdf', this.pMoralForm.get('comprobanteRfc').value);
    zip.file('edoCtaRfc.pdf', this.pMoralForm.get('edoCtaRfc').value);

    if (this.mayor2500000) {
      zip.file('cartaLineaRfc.pdf', this.pMoralForm.get('cartaLineaRfc').value);
    }

    // ZipAud
    const zipAud = new JSZip();
    // Validar si el campo estados financieros
    // auditados no vienen vacíos
    if(this.pMoralForm.get('edoFinAuditadosPM').value !== ''){
      zipAud.file('edoFinAuditadosPM.pdf', this.pMoralForm.get('edoFinAuditadosPM').value);
    }
    
    zipAud.file('edoFinInternosPM.pdf', this.pMoralForm.get('edoFinInternosPM').value);
    zipAud.file('relActActivosPM.pdf', this.pMoralForm.get('relActActivosPM').value);

    zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        zipAud.generateAsync({ type: 'blob' })
          .then(function (contentAud) {
            // console.log(content); return;
            const forma = new FormData();
            forma.append('nombre', _this.nombreContratista);
            forma.append('email', _this.emailContratista);
            forma.append('pruebazip.zip', content);
            forma.append('zipAud', contentAud);
            servicio.enviaArchivos(forma, str_rfc, id_contratista)
              .subscribe(resp => {
                console.log(resp);
                _this.cargando = false;

                _this.pMoral = false;
                _this.cargaArchivos = false;
                _this.envioCorrecto = true;
                // agregar Redirect Aquí

                // función de mandar correo aquí

              }, error => {
                console.error(error);
                _this.cargando = false;
                swal({
                  title: 'Error al enviar',
                  text: mensajeErrorEnvioDocumentos(error),
                  icon: 'error'
                });
              });
          });
      });

    return false;
    /*********************TERMINA JSZIP*********************************** */
  }
  /*-------------------------------------------------------------------------------- */



  /**+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/
  /**++++++++++++++++++++++++++++++Submit Persona física++++++++++++++++++++++++++++**/
  /**+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/


  // Submit Persona física
  onSubmitFisica() {

    this.submittedF = true; // activa validaciones del formulario
    this.cargando = true;
    const servicio = this._inicioService;
    const str_rfc = this.rfc_contratista;
    const id_contratista = this.idContratista;

    const _this = this;

    // Validar si el documento de Estados financieros 
    // auditados vienen vacíos
    if(this.pFisicaForm.get('edoFinAuditadosPF').value === '' || this.pFisicaForm.get('edoFinAuditadosPF').value === null) 
    {
      this.pFisicaForm.get('edoFinAuditadosPF').setValidators([]);
      this.pFisicaForm.get('edoFinAuditadosPF').updateValueAndValidity();;

    } else{
      this.pFisicaForm.get('edoFinAuditadosPF').setValidators([validarDocumento]);
      this.pFisicaForm.get('edoFinAuditadosPF').updateValueAndValidity();;
    }

    

    if (this.pFisicaForm.invalid) {
      console.log(this.pFisicaForm);
      this.cargando = false;
      return;
    }


    /************************PRUEBA DE JSPDF*************************** */

    const zip = new JSZip();
    zip.file('identificacion_Oficial_PF.pdf', this.pFisicaForm.get('identificacionOficial').value);
    zip.file('rfc_PF.pdf', this.pFisicaForm.get('rfcFisica').value);
    zip.file('registro_Patronal_PF.pdf', this.pFisicaForm.get('registroPatronalF').value);
    zip.file('edo_Cuenta_PF.pdf', this.pFisicaForm.get('edoCtaF').value);
    zip.file('comprobante_Dom_PF.pdf', this.pFisicaForm.get('comprobanteDomF').value);

    if (this.mayor2500000) {
      zip.file('carta_Linea_afianzamiento_PF.pdf', this.pFisicaForm.get('cartaLineaF').value);
    }

    // ZipAud
    const zipAud = new JSZip();

    // Validar si el campo estados financieros
    // auditados no vienen vacíos
    if(this.pFisicaForm.get('edoFinAuditadosPF').value !== ''){
      zipAud.file('edoFinAuditadosPF.pdf', this.pFisicaForm.get('edoFinAuditadosPF').value);
    }

    zipAud.file('edoFinInternosPF.pdf', this.pFisicaForm.get('edoFinInternosPF').value);
    zipAud.file('relActActivosPF.pdf', this.pFisicaForm.get('relActActivosPF').value);

    zip.generateAsync({ type: 'blob' })
      .then(function (content) {
        zipAud.generateAsync({ type: 'blob' })
          .then(function (contentAud) {

            const forma = new FormData();
            forma.append('nombre', _this.nombreContratista);
            forma.append('email', _this.emailContratista);
            forma.append('pruebazip.zip', content);
            forma.append('zipAud', contentAud);

            servicio.enviaArchivos(forma, str_rfc, id_contratista)
              .subscribe(resp => {
                console.log(resp);
                _this.cargando = false;

                // agregar Redirect Aquí

                swal({
                  title: 'Correcto!',
                  text: 'Envío correcto de documentos.',
                  icon: 'success',
                  buttons: [false],
                  timer: 1500
                })
                  .then(() => {
                    _this.pFisica = false;
                    _this.cargaArchivos = false;
                    _this.envioCorrecto = true;
                  });



              }, error => {
                console.error(error);
                _this.cargando = false;
                swal({
                  title: 'Error al enviar',
                  text: mensajeErrorEnvioDocumentos(error),
                  icon: 'error'
                });
              });

          });

      });

    return false;
    /*********************TERMINA PRUEBA*********************************** */

  }

}

// Termina clase                                          FIN<---------------


/**+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/
/**+++++++++++++++++++++++++++++++++VALIDACIONES++++++++++++++++++++++++++++++++++**/
/**+++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++**/

function validarDocumento(control: AbstractControl): { [key: string]: any } | null {
  console.log(control.value);
  if (control.value.type === 'application/pdf') {
    return null;
  }
  return { validarDocumento: true };
}

/** Cuando falla la red (p. ej. ERR_CONNECTION_RESET), no existe error.error.msg. */
function mensajeErrorEnvioDocumentos(err: any): string {
  const body = err && err.error;
  if (body && typeof body === 'object' && body.msg) {
    return body.msg;
  }
  if (err && err.status === 0) {
    return 'No hubo respuesta del servidor al subir los archivos. Suele deberse a la red, firewall, certificado SSL en el puerto del API, o a que el servicio reinició la conexión. Contacte a sistemas si persiste.';
  }
  if (typeof body === 'string' && body.length) {
    return body;
  }
  if (err && err.message) {
    return err.message;
  }
  return 'No se pudieron enviar los documentos. Intente más tarde.';
}

